export interface ApiError {
  code: string;
  status: string;
  title?: string;
  detail?: string;
}

// FIXME: Add explanation of errors + remove useless ones
export enum ApiErrorCode {
  OBSOLETE_API = "obsolete_api",
  OBSOLETE_CLIENT = "obsolete_client",
  INVALID_PASSWORD = "invalid_password",
  PASSWORD_TOO_SHORT = "password_too_short",
  ACCESS_TOKEN_EXPIRED = "access_token_expired",
  AUTH_FAILED = "auth_failed",
  USER_FORBIDDEN = "user_forbidden",
  EMAIL_ALREADY_USED = "email_already_used",
  USER_ALREADY_ACTIVE = "user_already_active",
  AMAZON_ACCOUNT_ALREADY_USED = "amazon_account_already_used",
  ACCOUNT_LOCKED = "account_locked",
  PIN_ERROR = "pin_error",
  NOT_SUBSCRIBED = "not_subscribed",
  ERROR_SERVER_LAUNCH = "error_server_launch",
  INVALID_OTP = "invalid_otp",
  MENU_NOT_FOUND_ERROR = "menu_not_found",
  /** @deprecated */
  ACCOUNT_LOCKED_ERROR = "account_locked",
  UNAUTHORIZED = "unauthorized",
  SUBSCRIPTION_NOT_FOUND = "subscription_not_found",
  USER_ALREADY_SUBSCRIBED = "user_already_subscribed",
  ACCOUNT_ALREADY_LINKED = "account_already_linked",
}
export const TIMEOUT_ERROR = "timeout";
export const GENERIC_ERROR = "Generic error";
